import React from 'react';
import { Button, Layout, Result } from 'antd';
import { styled } from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { t } from '../../../utils/i18n';

const StyledContent = styled(Layout.Content)`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.theme.antd.colorWhite};
`;

export function AccessDeniedPage() {
  const navigate = useNavigate();

  const handleOnBackToCalendarClick = () => {
    navigate(`/calendar`);
  };

  return (
    <StyledContent>
      <Result
        status="403"
        title={t('page-access-denied.title')}
        subTitle={t('page-access-denied.description')}
        extra={
          <Button type="primary" onClick={handleOnBackToCalendarClick}>
            {t('page-access-denied.button.back-to-calendar')}
          </Button>
        }
      />
    </StyledContent>
  );
}
